export const galleryIconSize = 15
export const contentPadding = 5
export const topPadding = 29
